import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { isMagStripe, submitMagstripe } from "./thunk";
import styled from "@emotion/styled";
import { OPEN_ERROR_BOX } from "../../constants/actionTypes";

const NotSupported = styled.div`
  display: flex;
  justify-content: center;
  color: red;
  border: 1px solid red;
  padding: 1rem;
`;

const EVENT_NAME = "mag-sensor";

const MAG = () => {
  const dispatch = useDispatch();
  const magSensorRef = useRef(null);
  const magstripe = useRef("null");
  const started = useRef(false);
  const finished = useRef(false);
  const [isFirefox, setIsFirefox] = useState(false);
  const [displayFirefoxMsg, setDisplayFirefoxMsg] = useState(false);

  const doReset = () => {
    magstripe.current = "";
    started.current = false;
    finished.current = false;
  };

  const onMagSensor = (e) => {
    if (e.type === EVENT_NAME) {
      e.preventDefault();

      const { charCode, keyCode } = e.detail;

      let key = String.fromCharCode(charCode);

      if (key === "%") {
        magstripe.current = "";
        started.current = true;
        finished.current = false;
      }

      if (keyCode === 13) finished.current = true;

      switch (key) {
        case "Enter":
          key = "\n";
          break;
        case "Tab":
          key = "\t";
          break;
      }

      if (started.current && !finished.current) {
        magstripe.current = magstripe.current + key;
      }

      if (started.current && finished.current) {
        if (!isMagStripe(magstripe.current)) {
          dispatch({
            type: OPEN_ERROR_BOX,
            payload: { message: "Please re-swipe the card" },
          });
        } else {
          dispatch(submitMagstripe(magstripe.current));
          doReset();
        }
      }
    }
  };

  useEffect(() => {
    if (window.navigator.userAgent.indexOf("Firefox") > -1) {
      setIsFirefox(true);
      setDisplayFirefoxMsg(true);

      // auto hide message
      setTimeout(() => {
        setDisplayFirefoxMsg(false);
      }, 30000);
    }

    if (!isFirefox) {
      if (magSensorRef && magSensorRef.current) {
        window.addEventListener("keypress", (e) => {
          magSensorRef.current.dispatchEvent(
            new CustomEvent(EVENT_NAME, {
              detail: e,
            })
          );
        });
        magSensorRef.current.addEventListener(EVENT_NAME, onMagSensor);
      }
    }

    return () => {
      if (!isFirefox) {
        if (magSensorRef && magSensorRef.current) {
          magSensorRef.current.removeEventListener(EVENT_NAME, onMagSensor);
        }
        doReset();
      }

      if (isFirefox) {
        setIsFirefox(false);
        setDisplayFirefoxMsg(false);
      }
    };
  }, []);

  if (isFirefox && displayFirefoxMsg)
    return (
      <NotSupported>
        The magnetic stripe swiping service is not available on the Firefox
        browser.
      </NotSupported>
    );

  return <div ref={magSensorRef}></div>;
};

export { MAG };
